<template>
  <v-dialog :value="loading" width="650">
    <v-card>
      <v-card-title class="text-h5" :style="stylef['button']">Loading</v-card-title>
      <div>
        <v-card-text>
          Your request is being processed.
          <v-progress-circular
            indeterminate
            :size="25"
            :color="stylef['main_color']"
            class="ml-2 mt-2"
          ></v-progress-circular>
        </v-card-text>
        <v-divider></v-divider>
      </div>
    </v-card>
  </v-dialog>
</template>
<script>
  export default {
    name: 'loader',
    props: ['loading', 'stylef'],
  };
</script>

<style scoped></style>
